import type { HTMLAttributeAnchorTarget, ReactNode } from 'react';
import type { OdinIconName } from '../../odin-icon/odin-icon.component';

export const SideNavigationItemsEnum = {
  ParentNavigationItem: 0,
  SubNavigationItem: 1,
} as const;
export type SideNavigationItemsEnum = (typeof SideNavigationItemsEnum)[keyof typeof SideNavigationItemsEnum];

export interface SideNavigationItemProps {
  label: string;
  icon: OdinIconName;
  to: unknown;
  state?: unknown;
  target?: HTMLAttributeAnchorTarget;
  badge?: BadgeItemProps;
  collapsedSubItems?: boolean;
  setCollapsedSubItems?: (value: boolean) => void;
  onClick?: () => void;
}

export interface BadgeItemProps {
  badgeNumber: number;
  description: ReactNode;
  closeTooltipOnClick?: boolean;
  lazyLoad?: boolean;
  showLoadingIndicator?: boolean;
}

export interface SideNavigationItem extends SideNavigationItemProps {
  subItems?: SideNavigationItemProps[];
}

export interface CompanyLogoProps {
  url?: string;
  isLoading: boolean;
}
